function s(r) {
  return !!(r != null && r.stockProductId && (r == null ? void 0 : r.stockCount) <= 0);
}
export {
  s as default
};
